module.exports = __webpack_public_path__ + "img/stock4.9b608333.png";